export const roundValueToQuarter = (value: number) => {
  // eslint-disable-next-line no-magic-numbers
  return Math.round(value * 4) / 4;
};
